// Material Dashboard 2 PRO React components
import { useState } from "react";
import axios from "axios";
import MDBox from "components/MDBox";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import { URL_API } from "config";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect } from "react";

function ModelDownload() {
  const [file, setFile] = useState();

  const getDownloadFiles = async () => {
    try {
      const res = await axios.get(URL_API + `/user-documents`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Tag")}`,
        },
      });

      setFile(res.data);
    } catch (error) {
      return 500;
    }
  }

  useEffect(() => {
    getDownloadFiles()
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <a
          href={file?.salaryStatement}
          download="Modelo_decalaração_de_salário"
        >
          <DefaultInfoCard
            icon="receipt"
            title="Modelo Declaração de Salário"
            value="Clique para obter Arquivo"
          />
        </a>
      </MDBox>

      <MDBox pt={6} pb={3}>
        <a
          href={file?.interestSheet}
          download="Modelo_Ficha_de_Interesse"
        >
          <DefaultInfoCard
            icon="receipt"
            title="Ficha de interesse"
            value="Clique para obter Arquivo"
          />
        </a>
      </MDBox>

      <MDBox pt={6} pb={3}>
        <a
          href={file?.selfDeclaration}
          download="Modelo_Autodeclaração_de_Endereço"
        >
          <DefaultInfoCard
            icon="receipt"
            title="Autodeclaração de Endereço"
            value="Clique para obter Arquivo"
          />
        </a>
      </MDBox>
    </DashboardLayout>
  );
}

export default ModelDownload;
